@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Thai:wght@300;400;500;600;700&family=Kanit:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600&display=swap');
@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --font-heading: 'Kanit', 'IBM Plex Sans Thai', system-ui, sans-serif;
  --font-body: 'IBM Plex Sans Thai', system-ui, sans-serif;
  --font-label: 'IBM Plex Sans Thai', system-ui, sans-serif;
  --font-mono: 'IBM Plex Mono', ui-monospace, monospace;

  --background-50: 0.984 0.003 248;
  --background-100: 0.968 0.007 248;
  --background-200: 0.929 0.013 255;
  --background-300: 0.869 0.019 252;
  --background-400: 0.804 0.024 250;
  --background-500: 0.704 0.032 248;
  --background-600: 0.620 0.037 250;
  --background-700: 0.554 0.041 257;
  --background-800: 0.446 0.037 257;
  --background-900: 0.372 0.030 257;
  --background-950: 0.278 0.030 253;

  --primary-50: 0.991 0.014 180;
  --primary-100: 0.960 0.040 179;
  --primary-200: 0.915 0.077 180;
  --primary-300: 0.861 0.117 181;
  --primary-400: 0.777 0.134 182;
  --primary-500: 0.531 0.091 181;
  --primary-600: 0.437 0.076 181;
  --primary-700: 0.376 0.062 179;
  --primary-800: 0.300 0.050 179;
  --primary-900: 0.245 0.042 178;
  --primary-950: 0.226 0.040 178;

  --secondary-50: 0.991 0.014 180;
  --secondary-100: 0.960 0.040 179;
  --secondary-200: 0.915 0.077 180;
  --secondary-300: 0.861 0.117 181;
  --secondary-400: 0.777 0.134 182;
  --secondary-500: 0.704 0.123 183.5;
  --secondary-600: 0.619 0.107 183;
  --secondary-700: 0.531 0.091 181;
  --secondary-800: 0.437 0.076 181;
  --secondary-900: 0.376 0.062 179;
  --secondary-950: 0.226 0.040 178;

  --accent-50: 0.987 0.021 95;
  --accent-100: 0.962 0.059 95;
  --accent-200: 0.924 0.115 94;
  --accent-300: 0.879 0.152 91;
  --accent-400: 0.828 0.170 84;
  --accent-500: 0.769 0.165 70;
  --accent-600: 0.666 0.157 58;
  --accent-700: 0.555 0.135 49;
  --accent-800: 0.470 0.111 44;
  --accent-900: 0.406 0.092 42;
  --accent-950: 0.279 0.074 41;

  --foreground-50: 0.984 0.003 248;
  --foreground-100: 0.968 0.007 248;
  --foreground-200: 0.929 0.013 255;
  --foreground-300: 0.869 0.019 252;
  --foreground-400: 0.704 0.032 248;
  --foreground-500: 0.620 0.037 250;
  --foreground-600: 0.554 0.041 257;
  --foreground-700: 0.446 0.037 257;
  --foreground-800: 0.372 0.030 257;
  --foreground-900: 0.300 0.028 255;
  --foreground-950: 0.259 0.028 253;
}

@layer base {
  html {
    scroll-behavior: smooth;
  }
  body {
    font-family: var(--font-body);
    background-color: oklch(var(--background-50));
    color: oklch(var(--foreground-900));
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }
  h1, h2, h3, h4, h5 {
    font-family: var(--font-heading);
    color: oklch(var(--foreground-950));
    letter-spacing: -0.01em;
  }
}

@layer utilities {
  .font-num {
    font-family: var(--font-mono);
    font-variant-numeric: tabular-nums;
  }
  .text-balance {
    text-wrap: balance;
  }
  .reveal {
    opacity: 0;
    transform: translateY(26px);
    transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1), transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
    will-change: opacity, transform;
  }
  .reveal.is-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .grid-lines {
    background-image: linear-gradient(oklch(var(--background-200) / 0.6) 1px, transparent 1px),
      linear-gradient(90deg, oklch(var(--background-200) / 0.6) 1px, transparent 1px);
    background-size: 28px 28px;
  }
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}

/* Anti-spam auxiliary field - hidden without obvious utility classes */
.form-aux-field {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  opacity: 0.001;
  pointer-events: none;
}

.spark-area-chart .recharts-area-area {
  fill: oklch(var(--secondary-200));
  fill-opacity: 0.55;
  transition: fill 0.35s ease;
}
.spark-area-chart .recharts-area-curve {
  stroke: oklch(var(--secondary-500));
  stroke-width: 2.5;
  transition: stroke 0.35s ease;
}
.spark-area-chart.is-up .recharts-area-area {
  fill: oklch(var(--secondary-200));
}
.spark-area-chart.is-up .recharts-area-curve {
  stroke: oklch(var(--secondary-500));
}
.spark-area-chart.is-down .recharts-area-area {
  fill: oklch(var(--accent-200));
}
.spark-area-chart.is-down .recharts-area-curve {
  stroke: oklch(var(--accent-500));
}

.spark-area-chart.is-flat .recharts-area-area {
  fill: oklch(var(--primary-200));
}

.spark-area-chart.is-flat .recharts-area-curve {
  stroke: oklch(var(--primary-500));
}

.spark-area-chart.is-flat .spark-active-dot {
  fill: oklch(var(--primary-500));
}

.spark-area-chart .spark-cursor {
  stroke: oklch(var(--foreground-300));
  stroke-width: 1;
  stroke-dasharray: 3 3;
}

.spark-area-chart .spark-active-dot {
  stroke: oklch(var(--background-50));
  stroke-width: 2;
  transition: fill 0.35s ease;
}

.spark-area-chart.is-up .spark-active-dot {
  fill: oklch(var(--secondary-500));
}

.spark-area-chart.is-down .spark-active-dot {
  fill: oklch(var(--accent-500));
}

.spark-area-chart .recharts-tooltip-wrapper {
  pointer-events: none;
}

::selection {
  background-color: oklch(var(--primary-200));
  color: oklch(var(--foreground-950));
}

@media (prefers-reduced-motion: reduce) {
  .reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
  html {
    scroll-behavior: auto;
  }
}

/* Floating broker quick-pick panel */
@keyframes fabPanelIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.fab-panel {
  animation: fabPanelIn 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  transform-origin: bottom right;
}

@media (prefers-reduced-motion: reduce) {
  .fab-panel {
    animation: none;
  }
}